<template>
	<div class="addPosition">
		<el-container>
			<el-header class="management_header">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的管理员{{showID}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="addControl()">+新增管理员</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="management_aside">
					<el-menu default-active="4" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoadd()">
							<span class="menuText" slot="title">新增岗位</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotoreset()">
							<span class="menuText" slot="title">查询/修改岗位信息</span>
						</el-menu-item>
						<el-submenu index="3">
							<template slot="title">
								<span class="menuText">查看简历</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="gotolookupresumeByName()">按人名查找</el-menu-item>
								<el-menu-item index="3-2" @click="gotolookupresume()">按时间、岗位查找</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item index="4">
							<span class="menuText" slot="title">招聘公告维护</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="management_body">
					<addControl v-show="addControlDialog" v-on:addAdmingAccount='addAdmingAccount'></addControl>
					<el-dialog title="公告新增	" :visible.sync="dialogAddArctict">
						<div class="add_arctict_name">
							名称
							<el-input placeholder="请输入名称" v-model="arctictName" clearable>
							</el-input>
						</div>
						<div slot="footer" class="dialog-footer">
							<el-button @click="dialogAddArctict = false">取 消</el-button>
							<el-button type="primary" @click="addNewArticle()">确 定</el-button>
						</div>
					</el-dialog>
					<div class="service_body">
						<div class="add_arctict_button">
							<el-link type="primary" @click="addArctict()">+ 新 增</el-link>
						</div>
						<div class="arctict_list">
							<el-table :data="arctictList" style="width: 100%" height="625">
								<el-table-column prop="articleName" label="ID">
								</el-table-column>
								<el-table-column prop="articleTitle" label="名称">
								</el-table-column>
								<el-table-column prop="articleUpdateTime" label="日期">
								</el-table-column>
								<el-table-column label="操作" width="150" fixed="right">
									<template slot-scope="scope">
										<el-button @click="modify(scope.row)" type="text" size="small">修改
										</el-button>
										<el-button @click="online(scope.row)" type="text" size="small"
											v-if="scope.row.articleStatus == 0">发布
										</el-button>
										<el-button @click="offline(scope.row)" type="text" size="small"
											v-if="scope.row.articleStatus == 1">下线
										</el-button>
										<el-button @click="deleteArticle(scope.row)" type="text" size="small">删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import addControl from "../../components/addControl.vue"
	import {
		loginstatus,
		Logout,
		addAdminUser,
		addPosition,
		uploadArticleFile,
		queryFileListOfArticle,
		deleteFileOfArticle,
		optArticle,
		queryArticle,
		queryArticleListBackend,
		addNewArticle,
		deleteArticle,
		updateStatusOfArticle,
	} from '../../api/user.js';
	import WangEditor from "@/components/weditor"
	export default {
		components: {
			addControl,
			WangEditor
		},
		data() {
			return {
				arctictList: [],
				addControlDialog: false,
				userID: '',
				showID: '',
				annexURL: '',
				dialogAddArctict: false,
				arctictName: '',
			}
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 300) {
					let str = res.data;
					this.showID = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userID = res.datadata
				} else {
					this.$message({
						message: '您不具有管理员权限！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
			queryArticleListBackend({
				currentPage: 1,
				pageCapacity: 9999,
			}).then((res) => {
				this.arctictList = res.data
			});
		},
		methods: {
			modify(row) {
				this.$router.push({
					path: '/management/recruitInfoService',
					query: {
						row: row
					}
				})
			},
			online(row) {
				updateStatusOfArticle({
					articleName: row.articleName,
					articleStatus: 1,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '发布成功！',
							type: 'success'
						});
						location.reload();
					} else {
						this.$message({
							message: '发布失败！',
							type: 'error'
						});
					}
				})
			},
			offline(row) {
				updateStatusOfArticle({
					articleName: row.articleName,
					articleStatus: 0,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '下线成功！',
							type: 'success'
						});
						location.reload();
					} else {
						this.$message({
							message: '下线失败！',
							type: 'error'
						});
					}
				})
			},
			deleteArticle(row) {
				deleteArticle({
					articleName: row.articleName,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '删除成功！',
							type: 'success'
						});
						location.reload();
					} else {
						this.$message({
							message: '删除失败！',
							type: 'error'
						});
					}
				})
			},
			addNewArticle() {
				addNewArticle({
					articleTitle: this.arctictName
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '新公告添加成功！',
							type: 'success'
						});
						this.dialogAddArctict = false;
						location.reload();
					} else {
						this.$message({
							message: '新公告添加失败！',
							type: 'error'
						});
					}
				})
			},
			addArctict() {
				this.dialogAddArctict = true
			},
			addAdmingAccount(addAdmingAccount) {
				addAdminUser({
					password: addAdmingAccount.adminPassword,
					userID: addAdmingAccount.adminAccount,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '管理员账号添加成功！',
							type: 'success'
						});
						this.addControlDialog = false
					} else {
						this.$message({
							message: '管理员账号添加失败！',
							type: 'error'
						});
						this.addControlDialog = false
					}
				})
			},
			addControl() {
				this.addControlDialog = true
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotolookupresumeByName(){
				this.$router.push('/management/lookUpResumeByName')
			},
			gotoadd() {
				this.$router.push('/management/addPosition')
			},
			gotoreset() {
				this.$router.push('/management/resetPosition')
			},
			gotolookupresume() {
				this.$router.push('/management/lookUpResume')
			},
		},
	};
</script>

<style lang="scss">
	@import url(../../assets/css/managementcss.css);

	.service_body {
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-bottom: 35px;
	}

	.addPosition_title {
		font-size: 26px;
		font-weight: bold;
		margin-left: 40%;
		padding-top: 25px;
	}

	.addPosition_info {
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-top: 25px;
	}

	.ruleForm_info {
		width: 510px;
	}

	.add_button_area {
		margin-left: 34%;
		margin-top: 55px;
	}

	.editor {
		line-height: normal !important;
	}

	.add_arctict_button {
		padding-top: 15px;
		margin-bottom: 30px;
		margin-left: 85%;
	}

	.add_arctict_name {
		width: 80%;
		margin-left: 10%;
	}

	.arctict_list {
		width: 80%;
		margin-left: 10%;
	}
</style>
